import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import MOAudit from "../MOAudit";
import MODetails from "./MWoDetails/MODetails";
import MOFiles from "./MWoFiles/MOFiles";
import MOProducts from "./MWoProducts/MOProducts";

let COMPONENT_DETAILS_URL = "/manufacturer/m-orders/details";

export default function MoDetailsLayout() {
  let { m_woId } = useParams();
  const location = useLocation();
  const MOrders = location.state?.MOrders || [];

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  const [allMWo, setAllMWo] = useState(MOrders || []);
  const [selectedWO, setSelectedMWo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  const updateSearchParams = (key, value) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);

      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }

      return newParams.toString();
    });
  };

  // Get Wo by id from db
  const GetWoById = async (m_woId) => {
    try {
      loadingOn();
      const { data } = await API.get(`/m-order/${m_woId}`, {
        headers: authHeader(),
      });
      if (data?.success) {
        setSelectedMWo(data?.data);
      } else {
        dispatch(
          setNotification({
            message: data?.message || "Failed to fetch work order",
            type: "error",
          })
        );
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const prevMOrder = () => {
    let curWOId = m_woId;
    let checkCrrIdExists = allMWo?.find(
      (item) => item?.m_woId === parseInt(curWOId)
    );
    if (!checkCrrIdExists) {
      return;
    }
    let currentIndex = allMWo?.indexOf(selectedWO);
    if (currentIndex === 0) {
      return;
    }
    let newId = allMWo[currentIndex - 1]?.m_woId;
    navigate(`${COMPONENT_DETAILS_URL}/${newId}?${searchParams.toString()}`, {
      state: { MOrders: allMWo },
    });
  };

  const nextMOrder = () => {
    let curWOId = m_woId;
    let checkCrrIdExists = allMWo?.find(
      (item) => item?.m_woId === parseInt(curWOId)
    );
    if (!checkCrrIdExists) {
      return;
    }
    let currentIndex = allMWo?.indexOf(selectedWO);
    if (currentIndex === allMWo.length - 1) {
      return;
    }
    let newId = allMWo[currentIndex + 1]?.m_woId;
    navigate(`${COMPONENT_DETAILS_URL}/${newId}?${searchParams.toString()}`, {
      state: { MOrders: allMWo },
    });
  };

  const handleViewCustomer = () => {
    navigate(`/customer/details/${selectedWO?.customer?.customerId}`);
  };

  const handleBack = () => {
    searchParams.delete("selected-tab");
    navigate(`/manufacturer/m-orders?${searchParams.toString()}`);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    if (allMWo.length > 0) {
      const foundMWo = allMWo.find((wo) => wo.m_woId === parseInt(m_woId));
      if (foundMWo) {
        setSelectedMWo(foundMWo);
      } else {
        GetWoById(m_woId);
      }
    }
    // If allMWo is empty, fetch the work order by ID
    else {
      GetWoById(m_woId);
    }
  }, [allMWo, m_woId]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      let tab = searchParams.get("selected-tab");
      if (tab) {
        setSelectedTab(tab);
        updateSearchParams("selected-tab", tab);
      } else {
        setSelectedTab("mo-details");
        updateSearchParams("selected-tab", "mo-details");
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  return (
    <div
      className=""
      style={{
        borderRadius: "10px",
        position: "fixed",
        top: 0,
        width: "calc(100vw - 180px)",
        paddingLeft: 80,
        marginLeft: 180,
        zIndex: 101,
      }}
    >
      <div className="bg-white px-4 shadow-lg py-2 w-100 d-flex justify-content-between align-items-center ">
        <div className="">
          <div className="mb-1">
            MO ID : {selectedWO?.m_woId}&nbsp;&nbsp;&nbsp;&nbsp;
            <span className="font-weight-bold h5">
              {selectedWO?.MOrder?.jobName?.toUpperCase()}
            </span>
          </div>
          <div>
            <button
              onClick={handleViewCustomer}
              className="btn btn-sm btn-info me-2 py-0 px-1 mb-1 "
            >
              View
            </button>
            <span className="mt-0">
              Customer ID :&nbsp;
              {selectedWO?.customer?.customerId}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className="font-weight-bold h5">
                {selectedWO?.customer?.customerName?.toUpperCase()}
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className="font-weight-bold h5">
                PO Required: &nbsp;
                {typeof selectedWO?.customer?.poRequired === "boolean"
                  ? selectedWO?.customer?.poRequired
                    ? "Yes"
                    : "No"
                  : "No Set"}
              </span>
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-end align-items-center ">
          <button onClick={handleBack} className={"btn btn-danger ms-1"}>
            BACK
          </button>

          <button
            onClick={() => {
              prevMOrder();
            }}
            className={"btn btn-success btn-sm p-0 px-1 mx-1"}
          >
            <i className="mdi mdi-arrow-left-bold fs-3 py-0 my-0"></i>
          </button>
          <button
            onClick={() => {
              nextMOrder();
            }}
            className={"btn btn-success btn-sm p-0 px-1 me-1"}
          >
            <i className="mdi mdi-arrow-right-bold fs-3 py-0 my-0"></i>
          </button>
          <Dropdown>
            <Dropdown.Toggle
              variant="primary"
              className="no-icon px-1"
              id="dropdown-basic"
            >
              <i className="mdi mdi-dots-vertical "></i>
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-25">
              <Dropdown.Item as="div" className="">
                Drop Down Item
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-3 py-2 d-flex justify-content-start align-items-center">
        <button
          className={`btn ${
            selectedTab === "mo-details" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("selected-tab", "mo-details");
          }}
        >
          MO Details
        </button>
        <button
          className={`btn ${
            selectedTab === "mo-products" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("selected-tab", "mo-products");
          }}
        >
          MO Products
        </button>
        <button
          className={`btn ${
            selectedTab === "mo-audit" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("selected-tab", "mo-audit");
          }}
        >
          MO Audit
        </button>
        <button
          className={`btn ${
            selectedTab === "mo-files" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("selected-tab", "mo-files");
          }}
        >
          MO Files
        </button>
      </div>

      {/* Content */}
      <div className="px-3 py-2">
        {selectedTab === "mo-details" && (
          <div>
            {/* Render Work Order Details Component */}
            <MODetails selectedWO={selectedWO} />
          </div>
        )}
        {selectedTab === "mo-products" && (
          <div>
            {/* Render Work Order Products Component */}
            <MOProducts selectedWO={selectedWO} />
          </div>
        )}
        {selectedTab === "mo-audit" && (
          <div>
            {/* Render Work Order Audit Component */}
            <MOAudit selectedWO={selectedWO} />
          </div>
        )}
        {selectedTab === "mo-files" && (
          <div>
            {/* Render Work Order Files Component */}
            <MOFiles selectedWO={selectedWO} />
          </div>
        )}
      </div>
    </div>
  );
}
